import React, { useCallback, useEffect, useRef, useState } from 'react';

const SPEED = 0.75;

export default function useAnimationLoop() {
  const containerRef = useRef(null);
  const translateXRef = useRef(0);
  const rafId = useRef();
  const lastSlideChange = useRef(0);
  const [direction, setDirection] = useState('left');
  const [translateX, setTranslateX] = useState(0);
  const [itemSetWidth, setItemSetWidth] = useState(0);
  const [paused, setPaused] = useState(true);
  const [hoverPosition, setHoverPosition] = useState(null);

  useEffect(() => {
    if (containerRef.current) {
      const singleSet = containerRef.current.querySelector('#item-set');
      if (singleSet) {
        const width = singleSet.scrollWidth;
        setItemSetWidth(width);
      }
    }
  }, []);

  useEffect(() => {
    const velocity = direction === 'left' ? -SPEED : SPEED;

    const animate = () => {
      if (!paused && containerRef.current) {
        let x = translateXRef.current + velocity;
        if (direction === 'left' && x < -itemSetWidth) {
          x += itemSetWidth;
        }
        if (direction === 'right' && x > 0) {
          x -= itemSetWidth;
        }
        translateXRef.current = x;
        containerRef.current.style.transform = `translate3d(${x}px,0,0)`;
      }
      rafId.current = requestAnimationFrame(animate);
    };

    rafId.current = requestAnimationFrame(animate);

    return () => {
      if (rafId.current) {
        cancelAnimationFrame(rafId.current);
      }
    };
  }, [direction, itemSetWidth, paused]);

  const handlePlay = useCallback(() => setPaused(false), []);
  const handleStop = useCallback(() => setPaused(true), []);

  const handleSetDirectionLeft = () => {
    setDirection('left');
  };
  const handleSetDirectionRight = () => {
    setDirection('right');
  };

  const handleMouseMove = (event, cardId) => {
    console.info(cardId);
    const rect = event.currentTarget.getBoundingClientRect();
    setHoverPosition({
      x: event.clientX - rect.left,
      y: event.clientY - rect.top,
      id: cardId,
    });
  };

  const handleMouseLeave = () => {
    setHoverPosition(null);
  };

  const handleMouseMoveContainer = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const cursorX = event.clientX - rect.left;
    const now = Date.now();
    if (now - lastSlideChange.current < 500) {
      return;
    }
    lastSlideChange.current = now;
    const leftBoundary = rect.width * 0.33;
    const rightBoundary = rect.width * 0.66;
    const isStopAutoPlay = cursorX >= leftBoundary && cursorX <= rightBoundary;
    if (isStopAutoPlay) {
      handleStop();
    } else {
      handlePlay();
    }
    if (cursorX < rect.width / 2) {
      handleSetDirectionRight();
    } else {
      handleSetDirectionLeft();
    }
  };

  return {
    containerRef,
    translateX,
    hoverPosition,
    onStop: handleStop,
    onPlay: handlePlay,
    onMouseMoveContainer: handleMouseMoveContainer,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave,
  };
}
